export const ASSOCIATE_PROFILE_DATA = [
	{
		title: {
			es: "Asocia tu institución",
			en: "Link your institution",
		},
		description: {
			es: 'Selecciona <strong>"Asociar institución"</strong> para comenzar.',
			en: 'Select <strong>"Link institution"</strong> to begin.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_1.png",
			en: "/img/personal-account/tutorial/en/vincular_1.png",
		},
	},
	{
		title: {
			es: "Busca tu institución",
			en: "Search your institution",
		},
		description: {
			es: "Escribe el nombre de tu institución en el buscador y selecciónala para continuar.",
			en: "Enter your institution's name in the search bar and select it to continue.",
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_2.png",
			en: "/img/personal-account/tutorial/en/vincular_2.png",
		},
	},
	{
		title: {
			es: "Accede con tus datos",
			en: "Log in with your credentials",
		},
		description: {
			es: "Serás redirigido al sistema de tu institución. Inicia sesión con tus credenciales para validar tu acceso.",
			en: "You will be redirected to your institution's system. Log in with your credentials to validate your access.",
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_3.png",
			en: "/img/personal-account/tutorial/en/vincular_3.png",
		},
	},
	{
		title: {
			es: "Confirma la vinculación",
			en: "Confirm the association",
		},
		description: {
			es: 'Verás un mensaje indicando que la institución fue asociada correctamente. Selecciona <strong>"Empezar a leer"</strong> para continuar.',
			en: 'You will see a message indicating that the institution was successfully linked. Select <strong>"Start reading"</strong> to continue.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_4.png",
			en: "/img/personal-account/tutorial/en/vincular_4.png",
		},
	},
	{
		title: {
			es: "Revisa tus instituciones",
			en: "Review your institutions",
		},
		description: {
			es: 'Ve a <strong>"Mi perfil"</strong> y selecciona <strong>"Tus instituciones"</strong> para consultar las vinculadas a tu cuenta.',
			en: 'Go to <strong>"My profile"</strong> and select <strong>"Your institutions"</strong> to view the ones linked to your account.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_5.png",
			en: "/img/personal-account/tutorial/en/vincular_5.png",
		},
	},
	{
		title: {
			es: "Instituciones asociadas",
			en: "Linked institutions",
		},
		description: {
			es: "Aquí podrás ver tus instituciones y los libros disponibles.",
			en: "Here you can see your linked institutions and the books available.",
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/vincular_6.png",
			en: "/img/personal-account/tutorial/en/vincular_6.png",
		},
	},
];
